

// import React, { createContext, useContext, useState, useEffect } from 'react';
// import { supabase } from '../lib/supabase';
// import { products } from '../data/productData';
// import { toast } from 'sonner';

// const CartContext = createContext();

// export const CartProvider = ({ children }) => {
//   const [cartItems, setCartItems] = useState([]);
//   const [loading, setLoading] = useState(true);

//   // Function to save cart to database
//   const saveCartToDatabase = async (userId, cartItems) => {
//     if (!userId || cartItems.length === 0) return;

//     try {
//       // Clear existing cart items for this user
//       await supabase.from('user_carts').delete().eq('user_id', userId);

//       // Insert current cart items
//       const cartData = cartItems.map(item => ({
//         user_id: userId,
//         product_id: item.id,
//         quantity: item.quantity || 1,
//         selected_color: item.selectedColor || null,
//         cart_id: item.cartId || item.id
//       }));

//       const { error } = await supabase.from('user_carts').insert(cartData);
//       if (error) console.error('Error saving cart:', error);
//     } catch (error) {
//       console.error('Error saving cart to database:', error);
//     }
//   };

//   // Function to load cart from database
//   const loadCartFromDatabase = async (userId) => {
//     if (!userId) return [];

//     try {
//       const { data, error } = await supabase
//         .from('user_carts')
//         .select('*')
//         .eq('user_id', userId);

//       if (error) {
//         console.error('Error loading cart:', error);
//         return [];
//       }

//       // Convert database cart back to cart items format
//       const cartItems = data.map(dbItem => {
//         const product = products.find(p => p.id === dbItem.product_id);
//         if (!product) return null;

//         return {
//           ...product,
//           quantity: dbItem.quantity,
//           selectedColor: dbItem.selected_color,
//           cartId: dbItem.cart_id
//         };
//       }).filter(Boolean);

//       return cartItems;
//     } catch (error) {
//       console.error('Error loading cart from database:', error);
//       return [];
//     }
//   };

//   // Listen for auth state changes
//   useEffect(() => {
//     const { data: { subscription } } = supabase.auth.onAuthStateChange(async (event, session) => {
//       if (event === 'SIGNED_IN' && session?.user) {
//         // User logged in - load their saved cart
//         setLoading(true);
//         const savedCart = await loadCartFromDatabase(session.user.id);
//         setCartItems(savedCart);
//         setLoading(false);
//       } else if (event === 'SIGNED_OUT') {
//         // User logged out - clear cart from state
//         setCartItems([]);
//       }
//     });

//     return () => subscription.unsubscribe();
//   }, []);

//   // Save cart whenever it changes (if user is logged in)
//   useEffect(() => {
//     const saveCart = async () => {
//       const { data: { user } } = await supabase.auth.getUser();
//       if (user && cartItems.length >= 0) {
//         await saveCartToDatabase(user.id, cartItems);
//       }
//     };

//     // Debounce the save operation
//     const timeoutId = setTimeout(saveCart, 1000);
//     return () => clearTimeout(timeoutId);
//   }, [cartItems]);

//   // Load cart on initial mount if user is already logged in
//   useEffect(() => {
//     const loadInitialCart = async () => {
//       const { data: { user } } = await supabase.auth.getUser();
//       if (user) {
//         setLoading(true);
//         const savedCart = await loadCartFromDatabase(user.id);
//         setCartItems(savedCart);
//         setLoading(false);
//       } else {
//         setLoading(false);
//       }
//     };

//     loadInitialCart();
//   }, []);

//   const addToCart = (product) => {
//     const existingItemIndex = cartItems.findIndex(
//       item => item.cartId === (product.cartId || product.id)
//     );

//     if (existingItemIndex >= 0) {
//       // Item exists, update quantity
//       const updatedCart = [...cartItems];
//       updatedCart[existingItemIndex].quantity += product.quantity || 1;
//       setCartItems(updatedCart);
//     } else {
//       // New item, add to cart
//       const newItem = {
//         ...product,
//         quantity: product.quantity || 1,
//         cartId: product.cartId || product.id
//       };
//       setCartItems(prev => [...prev, newItem]);
//     }
//   };

//   const removeFromCart = (cartId) => {
//     setCartItems(prev => prev.filter(item => item.cartId !== cartId));
//   };

//   const updateQuantity = (cartId, newQuantity) => {
//     if (newQuantity <= 0) {
//       removeFromCart(cartId);
//       return;
//     }

//     setCartItems(prev =>
//       prev.map(item =>
//         item.cartId === cartId ? { ...item, quantity: newQuantity } : item
//       )
//     );
//   };

//   // const clearCart = () => {
//   //   setCartItems([]);
//   // };


//   const clearCart = async () => {
//     setCartItems([]);
    
//     // Also clear from database if user is logged in
//     try {
//       const { data: { user } } = await supabase.auth.getUser();
//       if (user) {
//         await supabase.from('user_carts').delete().eq('user_id', user.id);
//       }
//     } catch (error) {
//       console.error('Error clearing cart from database:', error);
//     }
//   };

//   const getCartTotal = () => {
//     return cartItems.reduce((total, item) => total + (item.price * item.quantity), 0);
//   };

//   const getCartCount = () => {
//     return cartItems.reduce((total, item) => total + item.quantity, 0);
//   };

//   const value = {
//     cartItems,
//     loading,
//     addToCart,
//     removeFromCart,
//     updateQuantity,
//     clearCart,
//     getCartTotal,
//     getCartCount
//   };

//   return (
//     <CartContext.Provider value={value}>
//       {children}
//     </CartContext.Provider>
//   );
// };

// export const useCart = () => {
//   const context = useContext(CartContext);
//   if (!context) {
//     throw new Error('useCart must be used within a CartProvider');
//   }
//   return context;
// };

// export default CartContext;


import React, { createContext, useContext, useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';
import { products } from '../data/productData';
import { trackAddToCart } from '../lib/analytics';
import { withEffectivePricing } from '../utils/productPricing';

const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState([]);
  const [loading, setLoading] = useState(true);

  // Function to save cart to database
  const saveCartToDatabase = async (userId, cartItems) => {
    if (!userId || cartItems.length === 0) return;

    try {
      // Clear existing cart items for this user
      await supabase.from('user_carts').delete().eq('user_id', userId);

      // Insert current cart items
      const cartData = cartItems.map(item => ({
        user_id: userId,
        product_id: item.id,
        quantity: item.quantity || 1,
        selected_color: item.selectedColor || null,
        cart_id: item.cartId || item.id
      }));

      const { error } = await supabase.from('user_carts').insert(cartData);
      if (error) console.error('Error saving cart:', error);
    } catch (error) {
      console.error('Error saving cart to database:', error);
    }
  };

  // Function to load cart from database
  const loadCartFromDatabase = async (userId) => {
    if (!userId) return [];

    try {
      const { data, error } = await supabase
        .from('user_carts')
        .select('*')
        .eq('user_id', userId);

      if (error) {
        console.error('Error loading cart:', error);
        return [];
      }

      // Convert database cart back to cart items format
      const cartItems = data
        .map(dbItem => {
          const product = products.find(p => p.id === dbItem.product_id);
          if (!product) {
            // If product doesn't exist anymore, mark for deletion
            return { _shouldDelete: true, id: dbItem.id };
          }

          return withEffectivePricing({
            ...product,
            quantity: dbItem.quantity,
            selectedColor: dbItem.selected_color,
            cartId: dbItem.cart_id
          });
        })
        .filter(item => {
          if (item._shouldDelete) {
            // Delete orphaned cart items
            supabase.from('user_carts').delete().eq('id', item.id).then();
            return false;
          }
          return true;
        });

      return cartItems;
    } catch (error) {
      console.error('Error loading cart from database:', error);
      return [];
    }
  };

  // Listen for auth state changes
  useEffect(() => {
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      // Defer DB/auth calls out of this callback — Supabase holds an
      // internal auth lock for its whole duration, and awaiting other
      // supabase.auth.* calls from inside it deadlocks every future
      // auth call on the page.
      if (event === 'SIGNED_IN' && session?.user) {
        setTimeout(async () => {
          setLoading(true);
          const savedCart = await loadCartFromDatabase(session.user.id);
          setCartItems(savedCart);
          setLoading(false);
        }, 0);
      } else if (event === 'SIGNED_OUT') {
        // User logged out - clear cart from state
        setCartItems([]);
      }
    });

    return () => subscription.unsubscribe();
  }, []);

  // Save cart whenever it changes (if user is logged in)
  useEffect(() => {
    const saveCart = async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (user && cartItems.length >= 0) {
        await saveCartToDatabase(user.id, cartItems);
      }
    };

    // Debounce the save operation
    const timeoutId = setTimeout(saveCart, 1000);
    return () => clearTimeout(timeoutId);
  }, [cartItems]);

  // Load cart on initial mount if user is already logged in
  useEffect(() => {
    const loadInitialCart = async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (user) {
        setLoading(true);
        const savedCart = await loadCartFromDatabase(user.id);
        setCartItems(savedCart);
        setLoading(false);
      } else {
        setLoading(false);
      }
    };

    loadInitialCart();
  }, []);

  const addToCart = (product) => {
    const quantityToAdd = product.quantity || 1;
    const pricedProduct = withEffectivePricing(product);
    const existingItemIndex = cartItems.findIndex(
      item => item.cartId === (pricedProduct.cartId || pricedProduct.id)
    );

    if (existingItemIndex >= 0) {
      const updatedCart = [...cartItems];
      updatedCart[existingItemIndex].quantity += quantityToAdd;
      setCartItems(updatedCart);
    } else {
      const newItem = {
        ...pricedProduct,
        quantity: quantityToAdd,
        cartId: pricedProduct.cartId || pricedProduct.id
      };
      setCartItems(prev => [...prev, newItem]);
    }

    trackAddToCart(pricedProduct, quantityToAdd);
  };

  const removeFromCart = async (cartId) => {
    // Remove from state
    setCartItems(prev => prev.filter(item => item.cartId !== cartId));
    
    // Explicitly delete from database
    try {
      const { data: { user } } = await supabase.auth.getUser();
      if (user) {
        const { error } = await supabase
          .from('user_carts')
          .delete()
          .eq('user_id', user.id)
          .eq('cart_id', cartId);
        
        if (error) {
          console.error('Error removing item from database:', error);
        }
      }
    } catch (error) {
      console.error('Error removing cart item:', error);
    }
  };

  const updateQuantity = (cartId, newQuantity) => {
    if (newQuantity <= 0) {
      removeFromCart(cartId);
      return;
    }

    setCartItems(prev =>
      prev.map(item =>
        item.cartId === cartId ? { ...item, quantity: newQuantity } : item
      )
    );
  };

  const clearCart = async () => {
    setCartItems([]);
    
    // Also clear from database if user is logged in
    try {
      const { data: { user } } = await supabase.auth.getUser();
      if (user) {
        await supabase.from('user_carts').delete().eq('user_id', user.id);
      }
    } catch (error) {
      console.error('Error clearing cart from database:', error);
    }
  };

  const getCartTotal = () => {
    return cartItems.reduce((total, item) => total + (item.price * item.quantity), 0);
  };

  const getCartCount = () => {
    return cartItems.reduce((total, item) => total + item.quantity, 0);
  };

  const value = {
    cartItems,
    loading,
    addToCart,
    removeFromCart,
    updateQuantity,
    clearCart,
    getCartTotal,
    getCartCount
  };

  return (
    <CartContext.Provider value={value}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => {
  const context = useContext(CartContext);
  if (!context) {
    throw new Error('useCart must be used within a CartProvider');
  }
  return context;
};

export default CartContext;
